import { render, staticRenderFns } from "./itemordersummary.vue?vue&type=template&id=3974673c"
import script from "./itemordersummary.vue?vue&type=script&lang=js"
export * from "./itemordersummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports